(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["webnetz-click-event"] && !Shopify.designMode) return;
  try {
    function getClickContext(element) {
    const landmarks = [];
    let el = element.parentElement;

    while (el) {
      const tag = el.tagName?.toLowerCase();

      if (el.id?.startsWith('shopify-section-')) {
        const sectionType = el.id.replace('shopify-section-', '');
        landmarks.unshift(`section:${sectionType}`);
        break;
      }

      if (['header', 'footer', 'nav', 'main', 'aside', 'article'].includes(tag)) {
        const label = el.getAttribute('aria-label') || el.id;
        landmarks.unshift(label ? `${tag}:${label}` : tag);
      }

      el = el.parentElement;
    }

    return landmarks.join(' > ');
  }

  document.addEventListener('click', (event) => {
    const element = event.target;

    if (!(element instanceof Element)) {
      return;
    }

    const closestLink = element.closest('a');
    let relevantElement = null;

    if (closestLink) {
      relevantElement = closestLink;
    } else if (element.tagName && element.tagName.toLowerCase() === 'button') {
      relevantElement = element;
    }

    if (!relevantElement || !window.Shopify || !Shopify.analytics || !Shopify.analytics.publish) {
      return;
    }

    Shopify.analytics.publish('webnetz_click_event', {
      tagName: relevantElement.tagName?.toLowerCase() || '',
      href: relevantElement.href || '',
      text: relevantElement.innerText?.trim() || '',
      analytics: getClickContext(relevantElement),
      pageType: document.body.dataset.pageType || ''
    });
  });
  } catch(e) { console.error(e); }
})();

})();
